<div class="document-sheet" *ngIf="relations">
  <section class="document-section related-section">
    <header class="section-heading">
      <div>
        <h4>{{ settings[kind].title | translate }}</h4>
      </div>
      <div class="document-metrics" aria-label="Related message count">
        <div><strong>{{ messageCount }}</strong><span>Messages</span></div>
      </div>
    </header>

    <div class="related-generate" *ngIf="shownToGenerate.length > 0">
      <span class="related-label">{{ settings[kind].readyTitle | translate }}</span>
      <div class="related-row" *ngFor="let erpId of shownToGenerate">
        <span class="related-message-id">{{ erpId }}</span>
        <button type="button" class="btn btn-sm btn-primary" (click)="generate(erpId)">
          {{ 'GENERATE_MESSAGE' | translate }}
        </button>
      </div>
    </div>

    <ul class="related-messages" *ngIf="messageCount > 0; else noRelatedMessages">
      <ng-container *ngFor="let erpId of groupIds">
        <li class="related-row" *ngFor="let item of shownMessages[erpId]; index as i">
          <span class="related-message-id" *ngIf="item.id === currentMessageId; else messageLink">
            {{ item.id }} <span class="related-current">This document</span>
          </span>
          <ng-template #messageLink>
            <a class="related-message-id" [routerLink]="[settings[kind].route, item.id]">
              {{ item.id }} <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
            </a>
          </ng-template>
          <lib-edi-send-status class="edi-status-badge" [message]="item"></lib-edi-send-status>
          <span class="related-meta"><small>Validation</small>{{ item.validationState || '–' }}</span>
          <span class="related-meta">
            {{ (messageDate(item) | date: dateUtilService.dateFormat) || '–' }}
          </span>
          <lib-action-btn class="related-actions" [(item)]="shownMessages[erpId][i]" [config]="actionConfig"></lib-action-btn>
        </li>
      </ng-container>
    </ul>
    <ng-template #noRelatedMessages>
      <p class="related-empty">No {{ settings[kind].title | translate | lowercase }} for this order yet.</p>
    </ng-template>
  </section>
</div>
